// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as Rxjs from "../../Rxjs.bs.jsx";
import * as Rxjs$1 from "rxjs";
import * as React from "react";
import * as Header from "../../components/Header/Header.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as BeerList from "./BeerList.bs.jsx";
import * as DateUtils from "../../utils/DateUtils.bs.jsx";
import * as UserRoles from "../../backend/UserRoles.bs.jsx";
import * as Reactfire from "reactfire";
import * as DrinkDialog from "./DrinkDialog.bs.jsx";
import * as PlaceHeader from "../../components/PlaceHeader/PlaceHeader.bs.jsx";
import * as RouterUtils from "../../utils/RouterUtils.bs.jsx";
import * as Auth from "rxfire/auth";
import * as BackendUtils from "../../utils/BackendUtils.bs.jsx";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Firestore from "rxfire/firestore";
import * as FormattedCurrency from "../../components/FormattedCurrency/FormattedCurrency.bs.jsx";
import * as NotificationHooks from "../../backend/NotificationHooks.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import PlaceModuleCss from "./Place.module.css";
import * as NotificationDialog from "./NotificationDialog.bs.jsx";

let classes = PlaceModuleCss;

function pageDataRx(auth, firestore, placeId) {
  let placeRef = Db.placeDocument(firestore, placeId);
  let placeRx = Firestore.docData(placeRef, { "idField": "uid" });
  let chargedKegsRx = Db.allChargedKegsRx(firestore, placeId);
  let placeTapsRx = Rxjs.op(Rxjs.op(placeRx, Rxjs$1.distinctUntilChanged((prev, curr) => {
    if (prev !== undefined && curr !== undefined) {
      return Primitive_object.equal(prev.taps, curr.taps);
    } else {
      return false;
    }
  })), Rxjs$1.map((maybePlace, param) => Stdlib_Option.map(maybePlace, place => place.taps)));
  let tapsWithKegsRx = Rxjs.op(Rxjs$1.combineLatest(placeTapsRx, chargedKegsRx), Rxjs$1.map((data, param) => {
    let placeTaps = data[0];
    if (placeTaps === undefined) {
      return {};
    }
    let chargedKegs = data[1];
    return Object.fromEntries(Stdlib_Array.filterMap(Object.entries(placeTaps), param => {
      let tap = param[0];
      return Stdlib_Option.map(Stdlib_Option.flatMap(Primitive_option.fromNull(param[1]), kegRef => chargedKegs.find(keg => Db.getUid(keg) === kegRef.id)), keg => [
        tap,
        keg
      ]);
    }));
  }));
  let unfinishedConsumptionsByUserRx = Rxjs.op(chargedKegsRx, Rxjs$1.map((chargedKegs, param) => {
    let consumptionsByUser = new Map();
    chargedKegs.forEach(keg => {
      Db.groupKegConsumptionsByUser(consumptionsByUser, keg);
    });
    consumptionsByUser.forEach(consumptions => {
      consumptions.sort((a, b) => DateUtils.compare(a.createdAt, b.createdAt));
    });
    return consumptionsByUser;
  }));
  let recentlyFinishedKegsRx = Db.recentlyFinishedKegsRx(firestore, placeId);
  let recentConsumptionsByUserRx = Rxjs.op(Rxjs$1.combineLatest(unfinishedConsumptionsByUserRx, recentlyFinishedKegsRx), Rxjs$1.map((param, param$1) => {
    let recentConsumptionsByUser = window.structuredClone(param[0]);
    param[1].forEach(keg => {
      Db.groupKegConsumptionsByUser(recentConsumptionsByUser, keg);
    });
    let twelweHoursAgo = Date.now() - Db.slidingWindowInMillis;
    return new Map(Array.from(recentConsumptionsByUser.entries(), param => {
      let consumptionsInSlidingWindow = param[1].filter(consumption => consumption.createdAt.getTime() > twelweHoursAgo);
      consumptionsInSlidingWindow.sort((a, b) => DateUtils.compare(a.createdAt, b.createdAt));
      return [
        param[0],
        consumptionsInSlidingWindow
      ];
    }));
  }));
  let personsAllRx = Db.PersonsIndex.allEntriesSortedRx(firestore, placeId);
  let currentUserRx = Rxjs.op(Auth.user(auth), Rxjs.keepMap(prim => {
    if (prim === null) {
      return;
    } else {
      return Primitive_option.some(prim);
    }
  }));
  return Rxjs$1.combineLatest(placeRx, personsAllRx, tapsWithKegsRx, unfinishedConsumptionsByUserRx, recentConsumptionsByUserRx, currentUserRx);
}

function Place(props) {
  let placeId = props.placeId;
  let auth = Reactfire.useAuth();
  let firestore = Reactfire.useFirestore();
  let pageDataStatus = Reactfire.useObservable(`Page_Place_` + placeId, pageDataRx(auth, firestore, placeId));
  let match = React.useState(() => "Hidden");
  let setDialog = match[1];
  let dialogState = match[0];
  let hideDialog = param => setDialog(param => "Hidden");
  let match$1 = pageDataStatus.data;
  if (match$1 === undefined) {
    return null;
  }
  let place = match$1[0];
  if (place === undefined) {
    return "Place not found";
  }
  let currentUser = match$1[5];
  let recentConsumptionsByUser = match$1[4];
  let tapsWithKegs = match$1[2];
  let dispatchFreeTableNotification = NotificationHooks.useDispatchFreeTableNotification(currentUser.uid, place, recentConsumptionsByUser);
  let dispatchFreshKegNotification = NotificationHooks.useDispatchFreshKegNotification(currentUser.uid, place);
  let match$2 = Stdlib_Option.getOrThrow(place.accounts[currentUser.uid], undefined);
  let currentUserRole = match$2[0];
  let isUserAuthorized = extra => UserRoles.isAuthorized(currentUserRole, extra);
  let formatConsumption = BackendUtils.getFormatConsumption(place.consumptionSymbols);
  let tmp;
  if (UserRoles.isAuthorized(currentUserRole, 50)) {
    let newrecord = {...RouterUtils.createAnchorProps(undefined, "./nastaveni")};
    tmp = <a
      {...newrecord} 
      className={Header.classes.buttonRight}
    >
      <span>
        {"⚙️"}
      </span>
      <span>
        {"Nastavení"}
      </span>
    </a>;
  } else {
    tmp = null;
  }
  let tmp$1;
  if (typeof dialogState !== "object") {
    if (dialogState === "Hidden") {
      tmp$1 = null;
    } else {
      let currentUserNotificationSubscription = Stdlib_Option.getOrThrow(place.accounts[currentUser.uid], undefined)[1];
      tmp$1 = <NotificationDialog.make
        currentUserNotificationSubscription={currentUserNotificationSubscription}
        currentUserUid={currentUser.uid}
        onDismiss={hideDialog}
        onUpdateSubscription={newNotificationSubscription => {
          Db.Place.updateNotificationSubscription(firestore, currentUser.uid, newNotificationSubscription, placeId);
        }}
        place={place}
      />;
    }
  } else {
    let person = dialogState.person;
    let personId = dialogState.personId;
    let tap = person.preferredTap;
    tmp$1 = <DrinkDialog.make
      formatConsumption={formatConsumption}
      personName={person.name}
      preferredTap={tap !== undefined ? tap : Object.keys(place.taps)[0]}
      onDeleteConsumption={consumption => {
        Db.Keg.deleteConsumption(firestore, placeId, consumption.kegId, consumption.consumptionId);
      }}
      onDismiss={hideDialog}
      onSubmit={values => {
        let keg = tapsWithKegs[values.tap];
        let kegRef = Db.kegDoc(firestore, placeId, Db.getUid(keg));
        dispatchFreeTableNotification();
        dispatchFreshKegNotification(keg);
        Db.Keg.addConsumption(firestore, {
          milliliters: values.consumption,
          person: Db.placePersonDocument(firestore, placeId, personId)
        }, kegRef.id, personId, placeId, values.tap);
        setDialog(param => "Hidden");
      }}
      tapsWithKegs={tapsWithKegs}
      unfinishedConsumptions={Stdlib_Option.getOr(match$1[3].get(personId), [])}
    />;
  }
  return <FormattedCurrency.Provider.make
    value={place.currency}
  >
    <div
      className={Styles.page.narrow + ` ` + classes.root}
    >
      <PlaceHeader.make
        buttonRightSlot={<div
          className={classes.toolbar}
        >
          {NotificationHooks.canSubscribe ? <button
              className={Header.classes.buttonRight}
              type={"button"}
              onClick={param => setDialog(param => "NotificationSettings")}
            >
              <span>
                {"📢"}
              </span>
              <span>
                {"Notifikace"}
              </span>
            </button> : null}
          {tmp}
        </div>}
        createdTimestamp={place.createdAt}
        placeName={place.name}
      />
      <main>
        <BeerList.make
          currentUserUid={currentUser.uid}
          formatConsumption={formatConsumption}
          isUserAuthorized={isUserAuthorized}
          onAddConsumption={param => {
            let person = param[1];
            let personId = param[0];
            setDialog(param => ({
              TAG: "AddConsumption",
              personId: personId,
              person: person
            }));
          }}
          onTogglePersonVisibility={param => {
            let person = param[1];
            let preferredTap = Stdlib_Option.isSome(person.preferredTap) ? undefined : Object.keys(place.taps)[0];
            Db.PersonsIndex.update(firestore, placeId, [[
                param[0],
                {
                  balance: person.balance,
                  name: person.name,
                  preferredTap: preferredTap,
                  recentActivityAt: person.recentActivityAt,
                  userId: person.userId
                }
              ]]);
          }}
          personEntries={match$1[1]}
          recentConsumptionsByUser={recentConsumptionsByUser}
        />
      </main>
      {tmp$1}
    </div>
  </FormattedCurrency.Provider.make>;
}

let make = Place;

export {
  classes,
  pageDataRx,
  make,
}
/* classes Not a pure module */
